import React from 'react';
import { routes, switchRoutes } from 'core/router/router';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { DossierConsentsScene, DossierDocumentsScene, DossierOccupantsScene, DossierSignatoriesScene, DossierSummaryScene, DossierTextScene, DossierUnknownScene, DossierValidatedScene, } from 'scenes';
import { DossierErrorScene } from 'scenes/dossier/dossier-error.scene';
export const DossierRouter = () => {
    const location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Switch, { location: location },
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.error, switchRoutes.dossierWithId.error] },
                React.createElement(DossierErrorScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.consents, switchRoutes.dossierWithId.consents] },
                React.createElement(DossierConsentsScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.signatories, switchRoutes.dossierWithId.signatories] },
                React.createElement(DossierSignatoriesScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.occupants, switchRoutes.dossierWithId.occupants] },
                React.createElement(DossierOccupantsScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.explications, switchRoutes.dossierWithId.explications] },
                React.createElement(DossierTextScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.summary, switchRoutes.dossierWithId.summary] },
                React.createElement(DossierSummaryScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.documents, switchRoutes.dossierWithId.documents] },
                React.createElement(DossierDocumentsScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.validated, switchRoutes.dossierWithId.validated] },
                React.createElement(DossierValidatedScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.dossier.unknown, switchRoutes.dossierWithId.unknown] },
                React.createElement(DossierUnknownScene, null)),
            React.createElement(Route, { path: '*' },
                React.createElement(Redirect, { to: routes.dossier.unknown })))));
};
